import { Typography } from 'antd';
import { checkForSuperAdmin } from '../../utils/checkRole';

/**
 * Orders table, Super Admins only: the email of the consumer who placed each order, right after the VIN, on both
 * the Active and Done tabs. The API returns the consumer's email to Super Admins only (new orders are visible to
 * every dealer), so nobody else gets the column.
 */
export const withOrderedByColumn = (columns, { currentUser, t, textStyle }) => {
    if (!checkForSuperAdmin(currentUser)) {
        return columns;
    }

    const orderedBy = {
        title: t('fields.orderedBy'),
        dataIndex: ['consumer', 'email'],
        key: 'orderedBy',
        width: 240,
        // long addresses are cut to the column, with the full one in a tooltip
        render: email => (
            <Typography.Text style={textStyle} ellipsis={email ? { tooltip: email } : false}>
                {email || '—'}
            </Typography.Text>
        ),
    };
    const vinIndex = columns.findIndex(column => column.key === 'vin');

    return [...columns.slice(0, vinIndex + 1), orderedBy, ...columns.slice(vinIndex + 1)];
};
